module.exports = __webpack_public_path__ + "img/goldenM_IA_Service.0721a495.svg";